import React from 'react'
import { H2, H3, BodyCopy } from '@components/Globals'
import { StyledA } from '@components/EventDetail/style'
import { ProfileCard } from '@components/Card/index'
import { StyledALink } from '../style'
import { StyledEventButton } from '@components/Button/style'
import { nodeLocaleToEnglishLanguage } from '@utils'
import A from '@components/A'
import { useLocale, useTranslatedTerms } from '@hooks'

const EventsSidebar = ({
  registrationLink,
  associatedPracticeAreas,
  pageSlugs,
  associatedProfessionals,
  eventDetail,
  file,
  url,
  saveFile,
  location,
  isPastEvent,
  parentPath,
  signUpForFutureEventsLink,
}) => {
  const { locale } = useLocale()
  const { getTranslatedTerm } = useTranslatedTerms()

  const removeProDups =
    associatedProfessionals?.length > 0 &&
    associatedProfessionals.reduce((acc, current) => {
      const pro = acc.find(item => item.id === current.id)
      if (!pro && current.active) {
        return acc.concat([current])
      } else {
        return acc
      }
    }, [])
  const localizedPracticeAreas =
    associatedPracticeAreas?.length > 0 &&
    associatedPracticeAreas.filter(
      practiceArea =>
        !practiceArea.displayOnSites ||
        practiceArea?.displayOnSites?.includes(
          nodeLocaleToEnglishLanguage[locale]
        )
    )
  return (
    <div>
      {localizedPracticeAreas && (
        <>
          <H3 marginBottom={12} fontSize="14px" color="gray">
            Practice Areas
          </H3>
          {localizedPracticeAreas?.map(p => (
            <BodyCopy key={p.id}>
              <StyledALink to={p?.slug} contentType="ContentfulPracticeArea">
                {p.title}
              </StyledALink>
            </BodyCopy>
          ))}
          <br />
        </>
      )}
      {registrationLink && !isPastEvent && (
        <StyledA href={registrationLink} displayNone>
          <StyledEventButton marginBottom="10px" active>
            REGISTER FOR THE EVENT
          </StyledEventButton>
        </StyledA>
      )}
      {eventDetail && location && !isPastEvent && (
        <StyledA
          onClick={() => saveFile(eventDetail, file)}
          href={url}
          download={file}
          displayNone
        >
          <StyledEventButton
            border="2px solid #B4A06E"
            color="#B4A06E"
            hoverColor
          >
            ADD EVENT TO CALENDAR
          </StyledEventButton>
        </StyledA>
      )}
      {isPastEvent && (
        <>
          <BodyCopy color="gold" fontSize="16px" fontWeight={700} mb="16px">
            EVENT ENDED
          </BodyCopy>
          {signUpForFutureEventsLink && (
            <A href={signUpForFutureEventsLink}>
              <StyledEventButton active px={2}>
                SIGN UP FOR OTHER EVENTS
              </StyledEventButton>
            </A>
          )}
        </>
      )}
      {removeProDups && (
        <>
          <H2 fontSize="1rem" marginTop={30}>
            {getTranslatedTerm('Contributor')}
          </H2>

          {removeProDups?.map(a => (
            <>
              <ProfileCard
                person={a}
                id={a.id}
                displayTitle
                displayDepartment
                displayContact
                displayAvatar
                defaultFontSize={16}
                contactUs
                float="left"
                flexDirection
                height="auto"
                padding="10px 0 0"
              />
            </>
          ))}
        </>
      )}
    </div>
  )
}

export default EventsSidebar
